"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statistics = [{
  id: "stat-1",
  value: "45K+",
  label: "LinkedIn Followers",
  description: "Engaged executive audience built through strategic authority content and consistent thought leadership."
}, {
  id: "stat-2",
  value: "1.2M",
  label: "Spotify Streams",
  description: "Organic reach and listenership generated across top-tier podcast appearances and audio campaigns."
}, {
  id: "stat-3",
  value: "350+",
  label: "Inbound Leads",
  description: "High-intent prospective clients delivered monthly through optimized search visibility and funnels."
}, {
  id: "stat-4",
  value: "15K+",
  label: "Newsletter Subscribers",
  description: "Direct subscriber community engaging weekly with proprietary marketing insights and breakdowns."
}];
export default function ImpactStatistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="impactstatistics" className="bg-background text-foreground py-32 md:py-48 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={isVisible ? "visible" : "hidden"} className="flex flex-col">
          {}
          <motion.div variants={itemVariants} className="mb-24 md:mb-32 max-w-3xl">
            <h2 className="font-default text-4xl md:text-6xl font-bold tracking-tight leading-tight">
              {"Data driven. Confident."}
              <br />
              <span className="text-foreground/60">
                {"Proof that the strategy works."}
              </span>
            </h2>
          </motion.div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 md:gap-12 lg:gap-16">
            {statistics.map((stat, i) => <motion.div key={stat.id} data-index={i} variants={itemVariants} className="flex flex-col">
                <Separator className="mb-8 bg-foreground/10 h-[2px]" />
                <div className="flex-1">
                  <span className="block font-default text-6xl md:text-7xl lg:text-8xl font-bold text-accent tracking-tighter mb-6">
                    {stat.value}
                  </span>
                  <h3 className="font-default text-2xl font-semibold mb-4">
                    {stat.label}
                  </h3>
                  <p className="font-sans text-foreground/70 leading-relaxed max-w-sm text-lg">
                    {stat.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          {}
          <motion.div variants={itemVariants} className="mt-24 md:mt-32 flex justify-start md:justify-end">
            <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-md px-8 py-6 text-lg font-default font-medium">
              <Link to="/ResultsPage">
                {"View Full Case Studies"}
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}